import { createSelector } from "@reduxjs/toolkit";

export const notificationsSelector = (state:any) => state.notifications;

export const reauthSelector = createSelector(
  notificationsSelector,
  (notifications) => notifications.get("reauth")
);
